export default function Grain() {
  return (
    <>
      <div className="grain hidden md:block" aria-hidden="true" />
      <div className="scanlines hidden md:block" aria-hidden="true" />
    </>
  );
}
